<template>
  <div class="login__content-wrap">
    <SuccessMessage
      :email="email"
      title="password reset"
      body="password reset instructions. For security purposes, if this
        email address is not associated with an existing MotionMail account, no
        email will be sent"
      v-if="done"
    />
    <div v-if="!done">
      <h2 class="login__section-title layout--margin-bottom-sm">
        Forgot Password?
      </h2>
      <p class="layout--margin-bottom-xl">
        No worries, let's help you out. Enter your email and we will send you a
        link to reset your password.
      </p>
      <form v-on:submit.prevent="handleSubmit">
        <div class="input-group__field-wrap input-group__field-wrap--wide">
          <label for="email" class="input-group__label">Email Address</label>
          <input
            id="email"
            class="input-group__input input-group__input--wide"
            :class="{
              'input-group__input--error': $v.email.$invalid && $v.email.$dirty,
            }"
            v-model="email"
            aria-required="true"
            :aria-invalid="$v.email.$invalid && $v.email.$dirty"
          />
          <div
            class="input-group__error"
            v-if="!$v.email.required && $v.email.$dirty"
            role="alert"
          >
            Please enter an email address
          </div>
          <div
            class="input-group__error"
            v-if="!$v.email.email && $v.email.$dirty"
            role="alert"
          >
            Please enter a valid email
          </div>
        </div>
        <LoadingButton
          type="submit"
          wide
          big
          class="button layout--margin-top-xs layout--margin-bottom-xs"
          :event="handleSubmit"
          :loading="$wait.is('resetting password')"
          label="Send reset email"
          loadingLabel="Sending..."
          :doneLoading="done"
          doneLoadingLabel="Sent!"
        />
      </form>
    </div>
    <router-link
      :to="{ name: 'login' }"
      class="link layout--margin-bottom-md layout--margin-top-md"
      >Return to login</router-link
    >
    <p>
      Having trouble? Please open a
      <a @click.stop href="https://motionmail.freshdesk.com/support/tickets/new" class="link"
        >support ticket</a
      >.
    </p>
  </div>
</template>

<script>
import { required, email } from "vuelidate/lib/validators";
import { mapActions } from "vuex";
import { mapWaitingActions } from "vue-wait";

import LoadingButton from "../../components/LoadingButton";
import SuccessMessage from "./SuccessMessage";

export default {
  name: "forgot-password",
  components: {
    LoadingButton,
    SuccessMessage,
  },
  data() {
    return {
      email: "",
      done: false,
      error: false,
    };
  },
  methods: {
    ...mapWaitingActions("account", { resetPassword: "resetting password" }),
    handleSubmit: function() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.resetPassword(this.email).then(() => {
          this.$v.$reset();
          this.done = true;
        });
      }
    },
  },
  validations: {
    email: {
      required,
      email,
    },
  },
};
</script>

<style></style>
